<div class="{{localService.selectedLanguageCode}}"
    *ngIf="localService.languageContent && localService.languageContent.sales_report && wrapper">
    <app-business-deductive *ngIf="businessId != '' && businessId != '0'" [currentBusinessId]="businessId"
        [businesses]="localService.loggedMember.businesses"></app-business-deductive>
    <div class="banner center" style="max-width:1000px;">
        <div class="row freeze_height">
            <div class="col-6" style="text-align: left;">
                <button type="button" class="btn btn-primary" style="margin: 5px;" (click)="onAction(2)">
                    {{localService.languageContent.sales_report.final_report}}
                </button>
            </div>
            <div class="col-6" style="text-align: right;">
                <button type="button" class="btn btn-primary" style="margin: 5px;" (click)="onAction(1)">
                    {{localService.languageContent.sales_report.partial_report}}
                </button>
            </div>
        </div>
        <div class="row row_header freeze_height">
            <div class="col-6">
                {{localService.languageContent.sales_report.report_time}}
            </div>
            <div class="col-3">
                {{localService.languageContent.sales_report.paid_amount}}
            </div>
            <div class="col-3">
                {{localService.languageContent.sales_report.grand_total}}
            </div>
        </div>
        <div class="custom_rows_body" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
            <div *ngFor="let item of wrapper.items;index as idx">
                <div class="row styled_row"
                    [ngClass]="item.v9 == '1' ? ('final_report' + (idx == 0 ? '_first' : '')) : 'partial_report'">
                    <div class="col-md-6">
                        <span class="en">
                            {{item.v1 | date : 'dd-MMM-yyyy hh:mm a'}}
                            &nbsp;-&nbsp;
                            {{item.v2 | date : 'dd-MMM-yyyy hh:mm a'}}
                        </span>
                        <span class="en">&nbsp;({{item.v8}})</span>
                    </div>
                    <div class="col-md-6">
                        <div class="row">
                            <div class="col-6 right">
                                <span class="en">{{item.v4}}</span>
                            </div>
                            <div class="col-6 right">
                                <span class="en">{{item.v3}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <app-paging [paging]="wrapper.paging" [IsSimple]="true" [IsShowSimpleCalenderRange]="true"
        [IsSimpleSearchBarReq]="false" (onPagingRefreshed)="onLoad()"></app-paging>
</div>
<div>
    <app-message-box *ngIf="isOpenConfirmationBox" [IsConfirmationType]="true" (onClose)="onConfirmed($event)"
        [IsPopup]="true" [message]="localService.languageContent.sales_report.need_final_report" />
</div>